<template>
  <section class="interview-image-wrapper">
    <img :src="imageSrc" alt="imageAlt">
  </section>
</template>

<script>
export default {
  props: {
    imageSrc: {
      type: String,
    },
    imageAlt: {
      type: String,
    },
  },
}
</script>

<style scoped lang="scss">
.interview-image-wrapper {
  text-align: center;
  img{
    width: 800px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/LP/atoms/InterviewImage.vue